/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Constants from "../../../../common/Constants";
import MasterList from "../../../common/MasterList";
import { useTranslation } from "react-i18next";

const JobCardList = (props) => {
    const { t } = useTranslation();
    const columnsData = [
        {
            name: t("msg_trasaction.msg_generatejobcard.slNo"),
            selector: (row) => row.slNo,
            sortable: true,
            width: "100px",
            cell: (row) => (
                <div>
                    <p className="m-0 p-0 pt-1 fw-datatable-row">{row.slNo} </p>
                </div>
            ),
        },
        {
            name: t("msg_trasaction.msg_generatejobcard.batchNo"),
            selector: (row) => row.batch,
            sortable: true,
            width: "120px",
            cell: (row) => (
                <div>
                    <p className="m-0 p-0 pt-1 fw-datatable-row">{row.batch} </p>
                </div>
            ),
        },
        {
            name: t("msg_trasaction.msg_generatejobcard.slCardNumber"),
            selector: (row) => row.slCardNo,
            sortable: true,
            width: "170px",
            cell: (row) => (
                <div>
                    <p className="m-0 p-0 pt-1 fw-datatable-row">{row.slCardNo} </p>
                </div>
            ),
        },
        {
            name: t("msg_trasaction.msg_generatejobcard.batchQuantity"),
            selector: (row) => row.originalQuantityPerJobCard,
            sortable: true,
            width: "170px",
            cell: (row) => (
                <div>
                    <p className="m-0 p-0 pt-1 fw-datatable-row">{row.originalQuantityPerJobCard} </p>
                </div>
            ),
        },
        {
            name: t("msg_trasaction.msg_generatejobcard.priority"),
            cell: (row) => (
                <>
                    {row.priority === "urgent" ? (
                        <span className="bg-table-status bg-table-danger-status">
                            {"URGENT"}
                        </span>

                    ) : (
                        <span className="bg-table-status  bg-table-info-status">
                            {"REGULAR"}
                        </span>
                    )}
                </>
            ),
            center: true,
            width: "180px",
        },
        {
            name: t("msg_trasaction.msg_generatejobcard.siliconize"),
            cell: (row) => (
                <>
                    {row.siliconize === "siliconize" ? (
                        <span className="bg-table-status bg-table-info-status">
                            {"SILICONIZE"}
                        </span>
                    ) : (
                        <span className="bg-table-status bg-table-info-status">
                            {"-"}
                        </span>
                    )}
                </>
            ),
            center: true,
            width: "180px",
        },
    ];

    return (
        <MasterList
            columnsData={columnsData}
            rowsData={props.rowsData}
            paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
            pagination
            selectableRows
            handleClose
            cardHeader={false}
        //handleOpen={handleOpen}
        //handleDelete={confirmBeforeDelete}
        //onSelectedRowsChange={handleRowSelected}
        />

    )

}

export default JobCardList
